import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  FaSearch,
  FaFilePrescription,
  FaBrain,
  FaBookMedical,
  FaUsers,
  FaCloudUploadAlt,
} from "react-icons/fa";

const Features = () => {
  const features = [
    {
      icon: <FaFilePrescription size={32} color="#2D8A7A" />,
      title: "Majistral Formül Arşivi",
      desc: "Yüzden fazla formül arasında hızlı arama yapın, içerikleri detaylı olarak inceleyin.",
    },
    {
      icon: <FaSearch size={32} color="#2D8A7A" />,
      title: "Akıllı Arama Motoru",
      desc: "İlaç, etken madde veya endikasyona göre saniyeler içinde filtrelenmiş sonuçlara ulaşın.",
    },
    {
      icon: <FaBookMedical size={32} color="#2D8A7A" />,
      title: "Detaylı Formül Bilgileri",
      desc: "Her formülün içerik, hazırlanış ve kullanım gibi detaylı bilgilerine rahatlıkla erişin.",
    },
    {
      icon: <FaUsers size={32} color="#2D8A7A" />,
      title: "Topluluğa Özel Blog Yazıları",
      desc: "Güncel eczacılık trendleri ve majistral formülasyonlar hakkında bilimsel yazılar.",
    },
    {
      icon: <FaBrain size={32} color="#2D8A7A" />,
      title: "Klinik Bilgi Modülü",
      desc: "Hastalık ve endikasyon bazlı, görsel destekli klinik bilgi modülüne erişin.",
    },
    {
      icon: <FaCloudUploadAlt size={32} color="#2D8A7A" />,
      title: "Önemli Bilgi Kaynakları",
      desc: "Alkol Hesaplama Aracı, Majistral SUT ve Kısaltmalar Sözlüğü gibi diğer önemli bilgi kaynakları.",
    },
  ];

  return (
    <section
      id="features"
      className="position-relative py-5"
      style={{
        background: "linear-gradient(180deg, #E7F5F2 0%, #FFFFFF 100%)",
        overflow: "hidden",
      }}
    >
      {/* Arka plan efekt */}
      <div
        className="position-absolute top-50 start-50 translate-middle opacity-50"
        style={{
          width: "900px",
          height: "900px",
          background: "radial-gradient(circle, #7DD1C0 0%, transparent 70%)",
          filter: "blur(100px)",
          zIndex: 0,
        }}
      ></div>

      <Container style={{ position: "relative", zIndex: 2 }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center mb-5"
        >
          <h2 className="fw-bold" style={{ color: "#2D8A7A" }}>
            Öne Çıkan Özellikler
          </h2>
          <p className="text-muted lead" style={{ maxWidth: "650px", margin: "0 auto" }}>
            Majistral App, uzmanlar için tasarlanmış yenilikçi bir dijital platformdur.
          </p>
        </motion.div>

        <Row className="g-4">
          {features.map((feature, index) => (
            <Col md={4} sm={6} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.6 }}
              >
                <Card className="feature-card border-0 shadow-sm text-center p-4 h-100">
                  <div className="mb-3">{feature.icon}</div>
                  <h5 className="fw-semibold" style={{ color: "#2D8A7A" }}>
                    {feature.title}
                  </h5>
                  <p className="text-muted small">{feature.desc}</p>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;